import { COLORS, COLOR_LABELS, START_INDEX } from '../../../shared/board';
import type { Color } from '../../../shared/board';

export const colors: Color[] = COLORS;

export function colorLabel(c: Color): string {
  return COLOR_LABELS[c];
}

/** Ring index for a token of `color` sitting at track distance `d` (1..51). */
export function ringForToken(color: Color, d: number): number {
  return (START_INDEX[color] + d - 1) % 52;
}